import { useEffect, useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import "./Header.css";

const PRIMARY_LINKS = [
	{ to: "/", label: "Home", isPublic: true },
	{ to: "/app", label: "Astrology", isPublic: false },
	{ to: "/plans", label: "Plans", isPublic: false },
	{ to: "/profile", label: "Profile", isPublic: false },
];

const Header = () => {
	const [menuOpen, setMenuOpen] = useState(false);
	const { user, logout, authLoading } = useAuth();
	const toggleMenu = () => {
		setMenuOpen((prev) => !prev);
	};
	useEffect(() => { }, []);

	const closeMenu = () => {
		window.scrollTo(0, 0);
		setMenuOpen(false);
	};

	const handleLogout = () => {
		logout();
		closeMenu();
	};
	const updatedPrimaryLinks = PRIMARY_LINKS.map((link) => {
		if (link.isPublic) {
			return link;
		}
		if (user) {
			return link;
		}
	}).filter((link) => link);
	// Helper to render actions (Login/User) to avoid duplication
	const renderActions = (isMobile = false) => (
		<div className={isMobile ? "site-mobile-menu__actions" : "site-header__actions"}>
			{user ? (
				<>
					<span className='site-nav__user'>
						{user.name ? `Hi, ${user.name}` : user.email}
					</span>
					<button
						type='button'
						className='site-nav__button'
						onClick={handleLogout}
						disabled={authLoading}
					>
						{authLoading ? "Signing out..." : "Log out"}
					</button>
				</>
			) : (
				<>
					<NavLink
						to='/login'
						className={({ isActive }) =>
							`site-nav__link ${isActive ? "is-active" : ""}`
						}
						onClick={closeMenu}
					>
						Login
					</NavLink>
					<Link
						to='/signup'
						className='site-nav__button site-nav__button--primary'
						onClick={closeMenu}
					>
						Signup
					</Link>
				</>
			)}
		</div>
	);

	return (
		<header
			className='site-header'
			style={{
				backgroundImage:
					"linear-gradient(to right, rgba(15, 23, 42, 0), rgba(15, 23, 42, 0), rgba(15, 23, 42, 0)), url('/BGforHeader.webp')",
				// gradient covers while image stretches fully with header
				backgroundSize: "cover, 100% 100%",
				backgroundPosition: "center center, center center",
				backgroundRepeat: "no-repeat, no-repeat",
			}}
		>
			<div className='site-header__top'>
				<Link
					to='/'
					className='site-logo'
					onClick={closeMenu}
					aria-label='Heliocentric AI home'
				>
					<img
						src='/logo.jpg'
						alt='Heliocentric AI'
						className='site-logo__img'
						loading='lazy'
					/>
				</Link>

				<div className='site-header__tagline'>
					<span className='site-header__tagline-main'>
						Discover Your Soul&apos;s Blueprint
					</span>
					<span className='site-header__tagline-sub'>
						Heliocentric astrology from the Sun
					</span>
				</div>

				{/* Desktop Actions (Top Right) */}
				{renderActions(false)}

				<button
					type='button'
					className='site-header__menu-toggle'
					onClick={toggleMenu}
					aria-label='Toggle navigation'
				>
					<span />
					<span />
					<span />
				</button>
			</div>

			{/* Desktop Navigation (Bottom Row) */}
			<div className='site-header__bottom'>
				<nav className='site-header__nav'>
					{updatedPrimaryLinks.map((link) => (
						<NavLink
							key={link.to}
							to={link.to}
							className={({ isActive }) =>
								`site-nav__link ${isActive ? "is-active" : ""}`
							}
							onClick={closeMenu}
						>
							{link.label}
						</NavLink>
					))}
				</nav>
			</div>

			{/* Mobile Menu Overlay */}
			<div className={`site-mobile-menu ${menuOpen ? "is-open" : ""}`}>
				<nav className='site-mobile-menu__nav'>
					{updatedPrimaryLinks.map((link) => (
						<NavLink
							key={link.to}
							to={link.to}
							className={({ isActive }) =>
								`site-nav__link ${isActive ? "is-active" : ""}`
							}
							onClick={closeMenu}
						>
							{link.label}
						</NavLink>
					))}
				</nav>
				{renderActions(true)}
			</div>
		</header>
	);
};

export default Header;
